import React from 'react'
import healthcare1 from '../images/sociazy1.png';
import healthcare2 from '../images/sociazy2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function Sociazy() {
  return (
    <>
      <section id="portfolio" className="container my-5">
        <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
          <div className="px-3 fw-bold responsive-heading">
            <span className="highlight-orange">Sociazy</span> – AI Powered Sales Automation Platform
          </div>


        </div>
      </section>

      <section className="container my-5">
        {/* Section 1: Project Overview */}
        <div className="row g-0 overflow-hidden shadow rounded">
          <div className="col-12 col-md-5">
            <img
              src={healthcare1}
              alt="Remente App Overview"
              className="img-fluid w-100 h-100 object-fit-cover"
            />
          </div>

          <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
            <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
              <span className="highlight-orange">Sociazy</span> – AI Powered Sales Automation Platform
            </h1>

            <p className="mb-3 ps-1">
              Sociazy is an intelligent AI-driven sales automation platform built to help businesses automate outreach,
              optimize conversions, and accelerate revenue growth with data-backed decision-making.
            </p>

            <p className="mb-3 ps-1">
              From AI-generated lead scoring and automated follow-ups to omnichannel messaging and real-time performance analytics,
              the platform empowers sales teams to close deals faster and operate with maximum efficiency.
            </p>


            <a
              href="/contact-us"
              className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
            >
              Contact Us
            </a>
          </div>
        </div>

        {/* Section 2: Summary & Team Info */}
        <div className="row g-0 overflow-hidden shadow rounded my-5">
          <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
            <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
              <span className="highlight-orange">Client:</span> Sociazy
            </h1>

            <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
            <p className="mb-3 ps-3">India</p>

            <h4 className="fw-bold mb-1 highlight-orange">Technology & Purpose</h4>
            <p className="mb-3 ps-3">
              AI Lead Scoring Engine, Sales Workflow Automation, CRM Integration, React, Node.js, Firebase, REST APIs, NLP Models, Analytics Dashboard
            </p>

            <h4 className="fw-bold mb-1 highlight-orange">Domain</h4>
            <p className="mb-3 ps-3">AI Sales Automation</p>

            <h4 className="fw-bold mb-1 highlight-orange">Team Involvement</h4>
            <p className="mb-3 ps-3">
              UI/UX Designer, 2 Frontend Engineers, Backend Developer, AI Engineer, Automation Specialist, QA Engineer
            </p>

            <h4 className="fw-bold mb-1 highlight-orange">Duration</h4>
            <p className="mb-4 ps-3">5 Months</p>

            <p className="mb-4 ps-3">
              Sociazy is an advanced AI-powered sales automation platform designed to empower businesses with predictive insights,
              automated outreach, and intelligent lead management. By combining conversational AI, smart follow-up automation,
              and real-time analytics, the platform helps sales teams focus on closing deals instead of manual tasks.
              With AI-driven lead scoring, omnichannel messaging, and seamless CRM syncing, Sociazy enables organizations to
              scale their sales process, improve conversions, and accelerate revenue growth effortlessly.
            </p>



            <a
              href="/contact-us"
              className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
            >
              Contact Us
            </a>
          </div>

          <div className="col-12 col-md-5">
            <img
              src={healthcare2}
              alt="Remente UI"
              className="img-fluid w-100 h-100 object-fit-cover"
            />
          </div>
        </div>

        {/* Section 3: Process & Key Features */}
        <div className="row g-0 overflow-hidden shadow rounded my-5">
          <div className="col-12 col-md-5">
            <img
              src={healthcare3}
              alt="Mental Wellness Features"
              className="img-fluid w-100 h-100 object-fit-cover"
            />
          </div>

          <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
            <h1 className="fw-bold mb-3">
              <span className="highlight-orange">Process</span>
            </h1>

            <p className="mb-3 ps-1">
              We engineered Sociazy with an AI-first architecture focused on automation, prediction accuracy, and high-performance scalability.
              The platform combines machine learning models, workflow automation, CRM syncing, and multi-channel communication tools to
              simplify and accelerate the entire sales pipeline. Our backend ensures real-time processing, secure data handling, and seamless integration
              with external systems.
            </p>

            <p className="mb-3 ps-1">
              The UI/UX was crafted to make AI-driven sales automation accessible to all users — from small teams to enterprise sales departments.
              A minimal, intuitive interface enables teams to manage leads, launch automated outreach flows, analyze performance,
              and collaborate effortlessly, without requiring technical expertise.
            </p>

            <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
            <ul className="ps-3 mb-4">
              <li className="mb-1">AI-powered lead scoring & prioritization</li>
              <li className="mb-1">Automated follow-up sequences with dynamic timing</li>
              <li className="mb-1">Omnichannel messaging: email, SMS, WhatsApp, and socials</li>
              <li className="mb-1">CRM syncing with real-time lead updates</li>
              <li className="mb-1">Advanced analytics dashboard with sales forecasting</li>
              <li className="mb-1">Custom workflow builder powered by AI triggers & actions</li>
            </ul>



            <a
              href="/contact-us"
              className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
            >
              Get Started
            </a>
          </div>
        </div>

        <OurPartner />
      </section>

    </>
  )
}

export default Sociazy